import { useAtomValue } from 'jotai'
import { useMemo } from 'react'

import { useDcQuery } from '@/features/dcs/hooks'
import { selectedDcIdAtom } from '@/routes/_protected/$tenantKey/-states'

import { CUSTOM_SHIPMENT_ORDER_IMPORTS } from '../custom-imports'

/**
 * 得意先/拠点専用の配送依頼インポート機能のうち、現在のテナント・
 * 選択中拠点(DC)で表示可能なものを判定するフック。
 * 配送依頼のインポートの入口（取り込み方法の画面）が、出す選択肢の判定に使う。
 */
export const useCustomShipmentOrderImports = (tenantKey: string) => {
  // selectedDcIdAtom の 0 は未選択を表す初期値のため、DC 取得を発火させない
  const selectedDcId = useAtomValue(selectedDcIdAtom)
  const { data: dc } = useDcQuery(
    tenantKey,
    selectedDcId === 0 ? undefined : selectedDcId
  )
  return useMemo(
    () =>
      CUSTOM_SHIPMENT_ORDER_IMPORTS.filter((customImport) =>
        customImport.canShow({ tenantKey, dcCode: dc?.code })
      ).map((customImport) => ({
        key: customImport.key,
        label: customImport.label,
        description: customImport.description
      })),
    [tenantKey, dc?.code]
  )
}
